import React from "react";
import "./css/index.css";
interface Props {
  OrderChange: (e: string, index: number) => void;
  index: number;
}

const OrderArrow = ({ OrderChange, index }: Props) => {
  return (
    <div className="order-arrow-comp">
      <button
        onClick={() => {
          OrderChange("down", index);
        }}
      >
        <img src="/assets/common/bottomline.svg" alt="" />
      </button>
      <button
        className="order-down-btn"
        onClick={() => {
          OrderChange("up", index);
        }}
      >
        <img src="/assets/common/bottomline.svg" alt="" />
      </button>
    </div>
  );
};

export default OrderArrow;
